module.exports = __webpack_public_path__ + "static/media/alerta.d0b3be03.wav";